"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGBaseScene = void 0;
class CTGBaseScene extends Phaser.Scene {
    init(data) {
        this._animate_in = false;
        if (data.animate_in) {
            // this._animate_in = true;
        }
    }
    create() {
        if (false) {
            this._block_width = 4;
            this._anim_blocks = [];
            const blocks_per_row = 64 / this._block_width;
            for (let x = 0; x < blocks_per_row; x++) {
                for (let y = 0; y < blocks_per_row; y++) {
                    this._anim_blocks.push(this.add.sprite((x + 0.5) * this._block_width, (y + 0.5) * this._block_width, 'pixel').setDisplaySize(this._block_width, this._block_width).setDepth(1000));
                }
            }
            this.animate_show_scene();
        }
        this._block_height = 2;
        this._anim_blocks = [];
        const y_blocks = 64 / this._block_height;
        for (let y = 0; y < y_blocks; y++) {
            this._anim_blocks.push(this.add.sprite(32, (y + 0.5) * this._block_height, 'pixel').setDisplaySize(64, this._block_height).setDepth(1000).setTint(0x0).setVisible(false));
        }
        if (this._animate_in) {
            this.animate_show_scene();
        }
    }
    animate_hide_scene(callback) {
        if (false) {
            const blocks_per_row = 64 / this._block_width;
            for (let idx = 0; idx < this._anim_blocks.length; idx++) {
                let x = Math.floor(idx / blocks_per_row);
                this._anim_blocks[idx].setScale(0, 0);
                this.tweens.add({
                    targets: this._anim_blocks[idx],
                    scaleX: this._block_width,
                    scaleY: this._block_width,
                    angle: 180,
                    _ease: 'Sine.easeInOut',
                    ease: 'Power2',
                    duration: 1000,
                    delay: 500 + x * 100,
                });
            }
        }
        for (let idx = 0; idx < this._anim_blocks.length; idx++) {
            let x = idx % 2 == 0 ? -32 : 96;
            this._anim_blocks[idx].x = x;
            this._anim_blocks[idx].setVisible(true);
        }
        this.tweens.add({
            targets: this._anim_blocks,
            x: 32,
            ease: 'Sine.easeInOut',
            duration: 500,
            onComplete: callback,
        });
    }
    animate_show_scene() {
        if (false) {
            const blocks_per_row = 64 / this._block_width;
            for (let idx = 0; idx < this._anim_blocks.length; idx++) {
                let x = Math.floor(idx / blocks_per_row);
                this._anim_blocks[idx].setScale(this._block_width, this._block_width);
                this.tweens.add({
                    targets: this._anim_blocks[idx],
                    scaleX: 0,
                    scaleY: 0,
                    angle: 180,
                    _ease: 'Sine.easeInOut',
                    ease: 'Power2',
                    duration: 1000,
                    delay: 500 + x * 100,
                });
            }
        }
        for (let idx = 0; idx < this._anim_blocks.length; idx++) {
            let x = idx % 2 == 0 ? -32 : 96;
            this._anim_blocks[idx].x = 32;
            this._anim_blocks[idx].setVisible(true);
            this.tweens.add({
                targets: this._anim_blocks[idx],
                x: x,
                ease: 'Sine.easeInOut',
                duration: 500,
            });
        }
    }
}
exports.CTGBaseScene = CTGBaseScene;
